import "../../../i18n/i18n";
import { selectCurrentDepartment } from "../departments/departmentsSlice";
import {
  driversSlice,
  driversAccessRequestsListByDepartmentAsync,
  driversOfADepartmentListAsync,
  selectDriversListStatus,
  selectDriverAccessRequestsListStatus,
} from "../../home/drivers/driversSlice";
import { SharedInterfaceDrivers } from "../../home/drivers/sharedInterface";
import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { DriversSidePanel } from "../../home/drivers/sidePanel/SidePanel";
import { DriversListType } from "../../home/drivers/driversAPI";
import { useNavigate } from "react-router-dom";
import {
  selectListAllVehiclesInDbStatus,
  listVehiclesByDepartmentAsync,
} from "../../home/vehicles/vehiclesSlice";
import {
  driversHistoryByDepartmentAsync,
  selectAdvancedAnalyticsVehiclesList,
  selectAdvancedAnalyticsVehiclesListStatus,
  selectDriversHistoryListStatus,
} from "../../home/fleet/fleetSlice";
import {
  selectTripsByDayList,
  selectTripsByDayStatus,
  tripsByDepartmentAsync,
} from "../../home/fleet/trips/tripsSlice";

export const DepartmentDrivers = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const department = useAppSelector(selectCurrentDepartment);
  const vehiclesStatus = useAppSelector(selectListAllVehiclesInDbStatus);
  const advancedAnalyticsVehicleList = useAppSelector(
    selectAdvancedAnalyticsVehiclesList,
  );
  const advancedAnalyticsVehicleListStatus = useAppSelector(
    selectAdvancedAnalyticsVehiclesListStatus,
  );
  const tripsByDayStatus = useAppSelector(selectTripsByDayStatus);
  const driversHistoryListStatus = useAppSelector(
    selectDriversHistoryListStatus,
  );
  const driversListStatus = useAppSelector(selectDriversListStatus);
  const tripsListInit = useAppSelector(selectTripsByDayList);
  const driversAccessRequestsListStatus = useAppSelector(
    selectDriverAccessRequestsListStatus,
  );

  useEffect(() => {
    if (department && driversAccessRequestsListStatus === "idle") {
      void dispatch(
        driversAccessRequestsListByDepartmentAsync(department.uuid),
      );
    }
  }, [department, dispatch, driversAccessRequestsListStatus]);

  useEffect(() => {
    if (department && driversListStatus === "idle") {
      void dispatch(driversOfADepartmentListAsync(department.uuid));
    }
  }, [dispatch, department, driversListStatus]);

  useEffect(() => {
    if (vehiclesStatus === "idle" && department) {
      void dispatch(
        listVehiclesByDepartmentAsync({ departmentUuid: department.uuid }),
      );
    }
  }, [dispatch, vehiclesStatus, department]);

  useEffect(() => {
    if (driversHistoryListStatus === "idle" && department) {
      void dispatch(driversHistoryByDepartmentAsync(department.uuid));
    }
  }, [dispatch, driversHistoryListStatus, department]);

  useEffect(() => {
    if (
      department &&
      department.hasAdvancedAnalytics &&
      driversListStatus === "success"
    )
      dispatch(
        driversSlice.actions.getEcoDrivingScoreAndDrivingEventsByDriver(
          tripsListInit,
        ),
      );
  }, [
    department,
    department?.hasAdvancedAnalytics,
    dispatch,
    driversListStatus,
    tripsListInit,
  ]);

  useEffect(() => {
    if (
      department &&
      department.hasAdvancedAnalytics &&
      advancedAnalyticsVehicleList &&
      advancedAnalyticsVehicleList.length > 0 &&
      advancedAnalyticsVehicleListStatus === "success" &&
      tripsByDayStatus === "idle"
    ) {
      void dispatch(
        tripsByDepartmentAsync({
          vehicles: advancedAnalyticsVehicleList,
        }),
      );
    }
  }, [
    dispatch,
    advancedAnalyticsVehicleListStatus,
    advancedAnalyticsVehicleList,
    tripsByDayStatus,
    department,
  ]);

  const sidePanelAction = useCallback(
    (props: Partial<DriversListType>) => {
      navigate(`/departments/drivers/${props.uuid}`);
    },
    [navigate],
  );

  return (
    <SharedInterfaceDrivers
      sidePanelAction={sidePanelAction}
      sidePanel={
        <DriversSidePanel
          hasAdvancedAnalytics={department?.hasAdvancedAnalytics ?? false}
        />
      }
    />
  );
};
